<template>
  <v-dialog v-model="isOpenDialog" persistent max-width="290">
    <v-card>
      <v-card-title v-if="dialogTitle !== ''" class="headline">{{
        dialogTitle
      }}</v-card-title>
      <v-card-text :class="$style.message">{{ dialogMessage }} </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat="flat" text @click="pushOK()">{{
          dialogOkBtn
        }}</v-btn>
        <v-btn color="green darken-1" flat="flat" text @click="pushCancel()">{{
          dialogCancelBtn
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "vc-share-alert-dialog",
  props: {
    // stateToProps
    alertDialogState: {
      type: Object,
      default: null
    },
    // actionsToProps
    closeAlertDialog: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  mounted: function() {},
  computed: {
    isOpenDialog: function() {
      return this.alertDialogState.isOpenDialog;
    },
    dialogTitle: function() {
      return this.alertDialogState.title !== null
        ? this.alertDialogState.title
        : "TITLE";
    },
    dialogMessage: function() {
      return this.alertDialogState.message !== null
        ? this.alertDialogState.message
        : "MESSAGE";
    },
    dialogOkBtn: function() {
      return this.alertDialogState.ok_btn !== null
        ? this.alertDialogState.ok_btn
        : "OK";
    },
    dialogCancelBtn: function() {
      return this.alertDialogState.cancel_btn !== null
        ? this.alertDialogState.cancel_btn
        : "CANCEL";
    }
  },
  methods: {
    pushOK() {
      this.closeAlertDialog(true);
    },
    pushCancel() {
      this.closeAlertDialog(false);
    }
  }
};
</script>
<style module>
.message {
  white-space: pre-line;
}
</style>
